import axios from 'axios'

var hostname = window.location.hostname;
const apiHost = hostname == 'store.drbingo.com' ? 'https://app.doutorbingo.com' : 'https://staging.doutorbingo.com';

const host = apiHost;
const form = (obj) => {
    let formData = new FormData();
    for (let key in obj) {
        typeof key !== "undefined" && formData.append(key, obj[key])
    }
    return formData
}

const getSessionId = () => {
    return axios.get(host + '/get_session_id.php')
}

const logOut = (sid) => {
    return axios.get(host + `/web_store_logout.php?platform=secret&sid=${sid}`)
}

const facebookConnect = (sid, access_token) => {
    return axios.post(host + `/web_store_login.php?platform=secret&sid=${sid}`, form({
        "network": 'facebook',
        "access_token": access_token
    }))
}

const googleConnect = (sid, auth_code) => {
    return axios.post(host + `/web_store_login.php?platform=secret&sid=${sid}`, form({
        "auth_code": auth_code,
        "network": "google"
    }))
}

const appleIdConnect = (sid, identityToken, appleId, email, fullName) => {
    return axios.post(host + `/web_store_login.php?platform=secret&sid=${sid}`, form({
        "identityToken": identityToken,
        "apple_id": appleId,
        "email": email,
        "fullName": fullName,
        "network": "apple"
    }))
}

const guestLogin = (sid, userId) => {
    return axios.post(host + `/web_store_login.php?platform=secret&sid=${sid}`, form({ "user_id": userId, "network": "guest" }))
}

const getProductList = (sid, userId, bonusId) => {
    let url = host + `/secret_purchase.php?platform=secret&sid=${sid}`;
    if(bonusId){
        url = url + `&bonus_id=${bonusId}`;
    }
    return axios.post(url, {
        "type": 'get_product_list',
        "user_id": userId
    })
}

const getProductHash = (userId, hash) => {
    return axios.post(host + '/secret_purchase.php?platform=secret', {
        "type": 'get_product_hash',
        "user_id": userId,
        "hash": hash
    })
}

const saveFreePurchase = (userId, hash) => {
    let formData = new FormData();
    formData.append("json", JSON.stringify({
        "hash": hash
    }))
    return axios.post(host + `/cmd.php?platform=secret&action=save_free_purchased&user_id=${userId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

const getPendingPurchase = (userId) => {
    return axios.post(host + '/secret_purchase.php', {
        "type": 'get_pending_purchase',
        "user_id": userId
    })
}

const collectPending = (userId, pendingId) => {
    return axios.post(host + '/secret_purchase.php', {
        "type": 'collect_pending_purchase',
        "user_id": userId,
        "pending_id": pendingId
    })
}

const collectAirShop = (userId) => {
    return axios.post(host + '/secret_purchase.php', {
        "type": 'air_shop_collection',
        "user_id": userId,
    })
}

const requestDynamicPoConfig = async (url) => {
    return await axios.get(url)
}

const collectFreeBonus = (userId, bonusId) => {
    let formData = new FormData();
    formData.append("json", JSON.stringify({
        "bonus_id": bonusId
    }))
    return axios.post(host + `/cmd.php?platform=secret&action=collect_free_bonus&user_id=${userId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export default {
    getSessionId: getSessionId,
    logOut: logOut,
    facebookConnect: facebookConnect,
    googleConnect: googleConnect,
    appleIdConnect: appleIdConnect,
    guestLogin: guestLogin,
    getProductList: getProductList,
    getProductHash: getProductHash,
    saveFreePurchase: saveFreePurchase,
    getPendingPurchase: getPendingPurchase,
    collectPending: collectPending,
    collectAirShop: collectAirShop,
    requestDynamicPoConfig: requestDynamicPoConfig,
    collectFreeBonus: collectFreeBonus
}



// WEBPACK FOOTER //
// ./src/network/api.js